<template>
  <div class="app-container">
    <!-- <div class="page-header">
      <img src="@/assets/nav/yz_nav_fh_w.png" alt="返回" class="back-icon" @click="goBack">
      <h1>头衔等级</h1>
      <div class="header-right">
        <p @click="toggleGrowthValueInfo">成长值说明</p>
      </div>
    </div> -->

    <van-nav-bar
      title="头衔等级"
      right-text="成长值说明"
      left-arrow
      fixed
      safe-area-inset-top
      id="nav-topp"
    >
      <template #left>
        <img
          class="back-icon"
          src="../../../assets/nav/yz_nav_fh_w.png"
          alt=""
          @click="goBack"
        />
      </template>
      <template #title>
        <h1 class="header-title">头衔等级</h1>
      </template>
      <template #right  class="header-right">
        <span @click="toggleGrowthValueInfo">成长值说明</span>
      </template>
    </van-nav-bar>


    <!-- 弹出层-->
    <van-popup v-model:show="state.showGrowthValueInfo" position="bottom" round :style="{ height: 'auto' }"
      close-on-click-overlay="true">
      <div class="splitTips">
        <h3>成长值说明</h3>
        <div class="splitTips-content">
          <img src="@/assets/vip/shuoming.png" alt="">
        </div>
      </div>
    </van-popup>

    <div class="page-content">
      <div class="avatarbox2">
        <img :src="state.avatar ? state.avatar : touxiang" class="avatar2" alt="" />
        <!-- <img v-if="state.selected_avatar.image_url" class="frame2" :src="state.selected_avatar.image_url" alt=""> -->
      </div>
      <!-- <img class="touxiang_touxian" :src="userAvatar" /> -->
      <p style="color: #CCCCCC;">{{ state.nicename }}</p>
    </div>
    <!-- 修改模板中的数据绑定，统一使用computed属性 -->
    <div class="footer">
      <img src="@/assets/vip/jindu_touxian.png" alt="等级进度" />
      <p class="footer-text">Lv.{{ userLevel }}</p> <!-- 当前等级 -->
      <p class="footer-text-r" sat>Lv{{ userLevel - 1 }}</p> <!-- 上一级等级 -->
      <p class="footer-text-y">Lv.{{ userLevel + 1 }}</p> <!-- 下一级等级 -->
      <p class="footer-text-z">当前成长积分 {{ currentGrowthValue }} 还差 {{ remainingGrowthValue }} 升级</p>
    </div>
    <div class="paihang">
      <img src="@/assets/vip/paigangbang_touxian.png" alt="" />
    </div>
    <!-- 排名 -->
    <div class="box-paihang">
      <div class="ranking-list">
        <!-- 使用v-for遍历toplists数组渲染排行榜 -->
        <div class="ranking-item" v-for="(item, index) in state.toplists" :key="index">
          <!-- 为前三名添加图片样式，其他保持文本样式 -->
          <div v-if="index + 1 === 1" class="ranking-medal gold-medal">
            <img src="@/assets/vip/top1.png" alt="第1名" class="medal-image" />
          </div>
          <div v-else-if="index + 1 === 2" class="ranking-medal silver-medal">
            <img src="@/assets/vip/top2.png" alt="第2名" class="medal-image" />
          </div>
          <div v-else-if="index + 1 === 3" class="ranking-medal bronze-medal">
            <img src="@/assets/vip/top3.png" alt="第3名" class="medal-image" />
          </div>
          <p v-else class="ranking-number">{{ index + 1 }}</p>
          <!-- 添加头像 -->
          <img class="ranking-avatar" :src="item.avatar" alt="用户头像" />
          <!-- 添加昵称 -->
          <div class="ranking-info">
            <p class="ranking-nickname">{{ item.user_nicename }}</p>
          </div>
          <!-- 添加右侧成长值 -->
          <p class="ranking-growth-value">{{ item.total_coin }} 成长值</p>
        </div>
      </div>
    </div>

    <!-- 用户个人信息展示 -->
    <span class="box-mi-ranking">
      <div class="mi-ranking">
        <img :src="state.avatar" alt="">
        <p class="chengzhangzhi-text3">{{ state.nicename }}</p>
        <p class="chengzhangzhi-text2">{{ currentGrowthValue }}成长值</p>
      </div>
    </span>

    <!-- 底部预留空间 -->
    <div class="bottom-space"></div>
    <!-- 添加图片加载动画 -->
    <div v-if="state.loading" class="loading-overlay">
      <img src="@/assets/animate/loading.gif" alt="加载中" class="loading-image" />
      <p>加载中...</p>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';
// 引入onActivated钩子
import { onActivated, computed, reactive } from 'vue';
import { useStore } from 'vuex';
import { getLevel } from '@/api/yzCommunity';
import { getQueryString } from '../../../utils/location';


export default {
  name: 'level',
  setup() {
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      showGrowthValueInfo: false,
      topinfo: {},
      loading: true, // 加载状态
      toplists: [],
      avatar: "",
      nicename: "",
      uid: ""
    });

    // 实现点击显示/隐藏成长值说明的方法
    const toggleGrowthValueInfo = () => {
      state.showGrowthValueInfo = true;
    };

    const userLevel = computed(() => state.topinfo.level);
    const currentGrowthValue = computed(() => state.topinfo.total_coin);
    const remainingGrowthValue = computed(() => state.topinfo.need_coin_for_next);

    // 实现返回方法
    const goBack = () => {
      window.document.location = "goBack://";
    };

    // 调用CommentsJuhe/levelinfo接口获取等级信息
    const getLevelInfo = async () => {
      state.loading = true
      state.topinfo = {
        level: 0,
        total_coin: 0,
        need_coin_for_next: 0,
        level_name: '',
        next_level: 0,
        next_level_name: ''
      };

      getLevel({
        uid: state.uid
      }).then(response => {
        console.log(response)
        if (response.data.code == 1) {
          state.topinfo = response.data.data.topinfo
          state.toplists = response.data.data.toplists
        }
      }).finally(() => {
        state.loading = false
      })
    };

    // 添加onActivated钩子，确保每次进入页面都重新请求数据
    onActivated(() => {
      state.avatar = getQueryString("avatar")
      state.nicename = getQueryString("nicename")
      state.uid = getQueryString("uid")
      getLevelInfo();
    });

    return {
      goBack,
      userLevel,
      currentGrowthValue,
      remainingGrowthValue,
      toggleGrowthValueInfo,
      state,
      store
    };
  }
};
</script>

<style scoped>

::v-deep .van-nav-bar__text {
  color: #fff;
}
::v-deep .van-nav-bar__right {
  color: #fff;
}
.van-nav-bar {
  background: #191A1C;
  top: 0px;
  left: 0px;
  width: 100%;
  padding-top: calc(50px + constant(safe-area-inset-top));
  padding-top: calc(50px + env(safe-area-inset-top));
}

.app-container {
  position: relative;
  min-height: 100%;
  background-color: #191A1C;
  color: #ffffff;
  overflow: hidden;
}

.page-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px;
  box-sizing: border-box;
  /* 为固定顶部导航栏添加安全区域适配 */
  padding-top: calc(20px + env(safe-area-inset-top));
  padding-top: calc(20px + constant(safe-area-inset-top));
}

.back-icon {
  width: 60px;
  height: 60px;
}

.page-header h1 {
  font-size: 32px;
  color: #fff;
  margin: 0;
  text-align: center;
  flex: 1;
}

.header-right {
  width: 60px;
  /* 改为自动宽度，以适应文字内容 */
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.header-title {
  font-size: 32px;
}
.header-right p {
  font-size: 28px;
  background: linear-gradient(0deg, #FFC081 0%, #8CFF99 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  white-space: nowrap;
  /* 防止文字换行 */
  margin: 0;
  /* 移除默认边距 */
}

.page-content {
  padding: 120px 30px 30px;
  text-align: center;
  font-size: 24px;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: calc(50px + env(safe-area-inset-top));
  margin-top: calc(50px + constant(safe-area-inset-top));
}

.page-content p {
  margin-bottom: 20px;
  margin-top: 24px;
}

.avatarbox2 {
  width: 144px;
  height: 144px;
  position: relative;
}

.avatarbox2 .avatar2 {
  position: absolute;
  top: 0;
  left: 0;
  width: 144px;
  height: 144px;
  border-radius: 50%;
  border: 4px solid #fff;
}

.avatarbox2 .frame2 {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 216px !important;
  height: 216px !important;
  transform: translate(-50%, -50%);
  display: none;
}


.footer {
  position: relative;
  margin-top: 20px;
  width: 100%;
  height: auto;
}

.footer img {
  width: 100%;
  height: 100%;
}

.footer-text {
  font-size: 26px;
  font-weight: bold;
  color: #360b0b;
  position: absolute;
  top: 4%;
  left: 50%;
  transform: translateX(-50%);
}

.footer-text-r {
  font-size: 16px;
  font-weight: bold;
  color: #421414;
  position: absolute;
  top: 44px;
  left: 120px;
  transform: translateX(-50%);
}

.footer-text-y {
  font-size: 16px;
  font-weight: bold;
  color: #421414;
  position: absolute;
  top: 44px;
  right: 102px;
}

.footer-text-z {
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  text-align: center;
}

.paihang {
  position: relative;
  margin-top: 20px;
  width: 100%;
  height: auto;
}

.paihang img {
  width: 100%;
  height: 100%;
}


.box-paihang {
  border-radius: 30px;
  background: #1F1E27;
  display: flex;
  width: 686px;
  height: 100%;
  min-height: 1080px;
  padding: 22px 16px;
  margin-left: 32px;
  margin-right: 32px;
}

.ranking-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.ranking-item {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 16px;
}

.ranking-medal {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}

.medal-image {
  width: 92px;
  height: 92px;
  object-fit: contain;
}

.box-mi-ranking {
  background: #1F1E27;
  border-radius: 48px 48px 0px 0px;
  display: flex;
  width: 750px;
  height: 220px;
  position: fixed;
  background: linear-gradient(#161620 0%, #38363B 100%);
  border: 2px solid #606062;
  /* 设置固定定位 */
  bottom: 0;
  /* 固定在底部 */
  left: 0;
  /* 左对齐 */
  z-index: 999;
  /* 确保在其他内容之上 */
}

.mi-ranking {
  display: flex;
  align-items: center;
  justify-content: center;
  top: 40px;
  position: absolute;
  width: 100%;
  /* 确保容器占满宽度 */
}

.mi-ranking img {
  width: 100px;
  height: 100px;
  margin-left: 32px;
  border-radius: 50%;
  border: 4px solid #fff;
}

.chengzhangzhi-text3 {
  font-size: 32px;
  /* 可以调整字体大小 */
  color: #ffffff;
  /* 设置与其他文本相同的颜色 */
  margin-left: 20px;
}

.chengzhangzhi-text2 {
  margin-left: auto;
  /* 使用margin-left: auto将元素推向右侧 */
  font-size: 32px;
  /* 可以调整字体大小 */
  color: #FAE8C9;
  /* 设置与其他文本相同的颜色 */
  margin-right: 32px;
}

/* 底部预留空间样式 */
.bottom-space {
  height: 300px;
  /* 设置足够的底部空间高度 */
  width: 100%;
}

/* 为弹出层内容添加样式 */
.splitTips {
  background: #fff;
  border-radius: 48px 48px 0 0;
  padding: 30px;
  color: #333;
  height: 1200px;
  overflow-y: auto;
  /* 确保滑动时背景色一直存在 */
}

.splitTips img {
  width: 100%;
  height: 100%;
  margin-bottom: 100px;
  margin-top: 20px;
}

.ranking-number {
  font-size: 32px;
  color: #ffffff;
  margin-right: 20px;
  width: 40px;
  text-align: center;
}

.ranking-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  margin-right: 20px;
}

.ranking-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.ranking-nickname {
  font-size: 24px;
  color: #ffffff;
  margin-bottom: 4px;
}

.ranking-growth-value {
  font-size: 24px;
  color: #FAE8C9;
  text-align: right;
}

/* 添加加载动画样式 */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  flex-direction: column;
  text-align: center;
}

.loading-image {
  width: 120px;
  height: 120px;
}
</style>
